import { WorkOrderDetailType } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import SummarySection from './SummarySection';
import WorkCustomFieldsSection from './WorkCustomFieldsSection';

import classes from './workOrderReport.module.css';

interface Props {
  workOrder: WorkOrderDetailType;
}

const WorkInfoReport = ({ workOrder }: Props) => {
  const isWorkInfoEmpty =
    isNilOrEmpty(workOrder?.fields) && isNilOrEmpty(workOrder?.summary);

  return (
    <div>
      <div className={classes.taskHeader}>
        <div className={classes.taskTitle}>Work Info</div>
      </div>
      {isWorkInfoEmpty ? (
        <div className={classes.emptySection}>No summary or custom fields.</div>
      ) : (
        <div>
          <SummarySection summary={workOrder?.summary} />
          <WorkCustomFieldsSection workOrder={workOrder} />
        </div>
      )}
    </div>
  );
};

export default WorkInfoReport;
